import { getUpdateUserProfileDto } from '@bcba/validators';

export const _GetUpdateUserProfileDto = getUpdateUserProfileDto();
export class UpdateUserProfileDto extends _GetUpdateUserProfileDto {}
